export default __webpack_public_path__ + "static/media/Front-Desk-Department.7376b449.jpg";